import React from 'react';
import { Link } from 'react-router-dom';
 
class Welcome extends React.Component {
    render(){
        return (
            <section id="welcome" className="welcome-area ptb-80">
                <div className="container">
                    <div className="section-title">
                        <h4>LugaL International Group</h4>
                        <h2>Bienvenidos</h2>
                        <p>Somos especialistas en Consultoría y Asesoría en Negocios Internacionales, Inversiones Extranjeras, Desarrollo de Proyectos, Compra-Venta de Commodities.</p>
                    </div>
                    
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="single-box">
                                <i className="fa fa-pencil-square-o icon"></i>
                                <h3>Colaboración</h3>
                                <p>En nuestro equipo encontrará el apoyo y las herramientas necesarias para alcanzar su objetivo.</p>
                                <Link to="#" title="Read More" className="link-btn"><i className="fa fa-arrow-right"></i></Link>
                            </div>
                        </div>
                        
                        <div className="col-lg-4 col-md-6">
                            <div className="single-box">
                                <i className="fa fa-laptop icon"></i>
                                <h3>Compromiso</h3>
                                <p>Desde el inicio nos comprometemos a darle seguimiento y definición a sus requerimientos.</p>
                                <Link to="#" title="Read More" className="link-btn"><i className="fa fa-arrow-right"></i></Link>
                            </div>
                        </div>
                        
                        <div className="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
                            <div className="single-box">
                                <i className="fa fa-life-ring icon"></i>
                                <h3>Lealtad</h3>
                                <p>Velamos por sus intereses y los defendemos en todos los escenarios posibles.</p>
                                <Link to="#" title="Read More" className="link-btn"><i className="fa fa-arrow-right"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default Welcome;